import { render, staticRenderFns } from "./DrawingPoint.vue?vue&type=template&id=2c85e2a3&scoped=true&"
import script from "./DrawingPoint.vue?vue&type=script&lang=js&"
export * from "./DrawingPoint.vue?vue&type=script&lang=js&"
import style0 from "./DrawingPoint.vue?vue&type=style&index=0&id=2c85e2a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85e2a3",
  null
  
)

export default component.exports